import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";

export const SimpleSubmitButton = ({ headerText, isSubmitting, isLocked }) => {
    return (
        <Button
            isDisabled={isLocked || isSubmitting}
            type="submit"
            w="100%"
            maxW={{ base: "100%", md: "186px" }}
            isLoading={isSubmitting}
        >
            <Text fontSize="desktopBodyTextSmall" fontWeight="bold">
                {headerText}
            </Text>
        </Button>
    );
};

export default SimpleSubmitButton;
